import en from "./locale/en.json"
import de from "./locale/de.json"
import fr from "./locale/fr.json"
import it from "./locale/it.json"

export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: { en, de, fr, it },
}))
